<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <transition name="modal">
    <div class="modal-wrapper" data-xpath="snooze-modal-wrapper">
      <div class="modal-container" data-xpath="snooze-modal-container">
        <div class="modal-title" data-xpath="snooze-modal-title">
          Snooze notifications
        </div>
        <div
          v-for="(snoozeItem, index) in snoozeTimes"
          :key="index"
          class="modal-item"
          @click="handleSnooze(snoozeItem.value)"
          :data-xpath="`snooze-option-${snoozeItem.title.toLowerCase().replace(' ', '-')}`"
        >
          <label :for="`${snoozeItem.title}-${snoozeItem.value}`" data-xpath="snooze-option-label">
            {{ snoozeItem.title }}
            <div class="svg" />
          </label>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import moment from 'moment';

// Define props
const props = defineProps({
	props: Object,
});

// Setup store
const store = useStore();

// Reactive state
const selected = ref(0);
const snoozeTimes = ref([
	{ title: 'Enable', value: 0 },
	{ title: '1 hour', value: 1 },
	{ title: '3 hours', value: 3 },
	{ title: '6 hours', value: 6 },
	{ title: '12 hours', value: 12 },
	{ title: '24 hours', value: 24 },
	{ title: '1 week', value: 168 },
]);

// Get account from store
const account = computed(() => store.getters.account);

// Methods
async function handleSnooze(time) {
	const formattedTime = time === 0
	  ? null
	  : moment()
		  .add(time, 'hours')
		  .toISOString();

	try {
	  await store.dispatch('setSnoozeTime', {
			notDisturbDate: formattedTime,
			id: account.value.id,
	  });
	  await store.dispatch('getAccountData');
	  props.props.closeModal();
	} catch (error) {
	  console.error('Error setting snooze time:', error);
	}
}
</script>

  <style scoped lang="scss">
@use '../../../styles/variables' as *;

.modal {
  &-wrapper {
    display: table-cell;
    vertical-align: middle;
    position: absolute;
    right: 9px;
    top: 120px;
    z-index: 1001;
    cursor: unset;
  }

  &-container {
    width: 255px;
    margin: 0px auto;
    padding: 0;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
    transition: all .3s ease;
    font-family: Helvetica, Arial, sans-serif;
    cursor: unset;
  }

  &-title {
    color: $sp-color-text-dark;
    padding: 19px 18px;
    cursor: default;
    font-weight: bold;
  }

  &-item {
    font-size: 14px;
    padding: 15px 18px;
    cursor: pointer;
    border-top: 1px solid #F1F6FF;

    label {
      color: #191933;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
      font-size: 14px;
      position: relative;
      width: 100%;
      margin: 0;
    }
  }

  &-item:hover {
    background-color: #F5F9FC;
  }
}
</style>
